















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class TimelineLegend extends Vue {
  @Prop(
      {type: Array as () => DisguiseDto.TimelineLegendElementDto[]})
  legendElements?: DisguiseDto.TimelineLegendElementDto[];
}
